"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _preact = require("preact");

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _Personalisation = require("@insided/destination/modules/Personalisation");

var _RadioInputGroup = _interopRequireDefault(require("@insided/shared/uikit/RadioInputGroup"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

var PUBLIC_SLOT = (0, _preact.h)("div", {
  className: "widget-visibility-selector"
}, (0, _preact.h)("strong", null, "Everyone"), (0, _preact.h)("span", {
  className: "text--meta"
}, " (same experience for everyone)"));
var PRIVATE_SLOT = (0, _preact.h)("div", null, (0, _preact.h)("strong", null, "Selected Segments"), (0, _preact.h)("span", {
  className: "text--meta"
}, " (tailored to specific segments)"));

var PersonalisationConfigurator = /*#__PURE__*/function (_Component) {
  (0, _inherits2.default)(PersonalisationConfigurator, _Component);

  var _super = _createSuper(PersonalisationConfigurator);

  function PersonalisationConfigurator() {
    var _this;

    (0, _classCallCheck2.default)(this, PersonalisationConfigurator);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));
    (0, _defineProperty2.default)((0, _assertThisInitialized2.default)(_this), "state", {
      isPrivateSelected: _this.props.filters !== null
    });
    return _this;
  }

  (0, _createClass2.default)(PersonalisationConfigurator, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          widgetPersonalisationOptions = _this$props.widgetPersonalisationOptions,
          controlUrl = _this$props.controlUrl,
          _onWidgetVisibilityUpdated = _this$props.onWidgetVisibilityUpdated,
          selectedPersonalisationFilters = _this$props.filters;
      var isPrivateSelected = this.state.isPrivateSelected;
      return (0, _preact.h)("div", {
        className: "widget-visibility-configurator"
      }, (0, _preact.h)("p", null, "Show this widget to"), (0, _preact.h)(_RadioInputGroup.default, {
        options: [PUBLIC_SLOT, PRIVATE_SLOT],
        onChange: function onChange(option) {
          _this2.setState({
            isPrivateSelected: option === PRIVATE_SLOT
          }, function () {
            _onWidgetVisibilityUpdated(option === PUBLIC_SLOT, false, []);
          });
        },
        value: isPrivateSelected ? PRIVATE_SLOT : PUBLIC_SLOT
      }), isPrivateSelected && (0, _preact.h)(_Personalisation.SegmentsSelector, {
        selectedPersonalisationFilters: selectedPersonalisationFilters,
        onWidgetVisibilityUpdated: function onWidgetVisibilityUpdated(isGuestUserSelected, selectedSegments) {
          _onWidgetVisibilityUpdated(!isPrivateSelected, isGuestUserSelected, selectedSegments);
        },
        controlUrl: controlUrl,
        widgetPersonalisationOptions: widgetPersonalisationOptions
      }));
    }
  }]);
  return PersonalisationConfigurator;
}(_preact.Component);

exports.default = PersonalisationConfigurator;